/*
 * cartActions.js
 * Created by michaelbray on 10/3/17
 */

import axios from 'axios';
import { getAuthHeader } from '../../helpers/securityHelper';
import * as types from '../actionTypes';

export function fetchCartHeader() {
    return (dispatch) => axios.get(`${process.env.API}/cart/shoppingcart/header`, { headers: { Authorization: getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART_HEADER, payload: response.data });
        })
        .catch(() => {
            dispatch({
                type: types.CART_ERROR,
                payload: 'Error fetching cart',
                error: true
            });
        });
}

export function fetchCart(lightweight) {
    if (lightweight) {
        return fetchCartHeader()
    }

    return (dispatch) => axios.get(`${process.env.API}/cart/shoppingcart`, { headers: { Authorization: getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART, payload: response.data });
        })
        .catch(() => {
            dispatch({
                type: types.CART_ERROR,
                payload: 'Error fetching cart',
                error: true
            });
        });
}

export function removeReservation(reservationID) {
    return (dispatch) => axios.delete(`${process.env.API}/cart/shoppingcart/${reservationID}`, { headers: { Authorization: getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART, payload: response.data });
        })
        .catch(() => {
            dispatch({ type: types.REMOVE_RESERVATION_ERROR, payload: 'Error removing item from cart' });
        });
}

export function extendTimer() {
    return (dispatch) => axios.patch(`${process.env.API}/cart/shoppingcart/expiration`, {}, { headers: { Authorization: getAuthHeader() } })
        .then((response) => {
            dispatch({ type: types.GET_CART, payload: response.data });
        })
        .catch(() => {
            dispatch({ type: types.EXTEND_EXPIRATION_ERROR, payload: 'Error extending expiration' });
        });
}
